<template>
  <div class="aiOne-container">
    <div class="aiOne_head">
      <div class="title">报警信息</div>
      <div class="colse" @click="updateWarn"><i class="el-icon-close"></i></div>
    </div>
    <div class="aiOne_body">
      <div class="item_one">
        <div class="title">报警快照</div>
        <div class="con"><img :src="dataOne.picture"/></div>
      </div>
      <div class="item_one">
        <div class="title">实时视频</div>
        <div class="con">
          <iframe
            :src="'https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/'+dataOne.number+'/'+dataOne.channel+'.live&autoplay=1&accessToken='+accessToken"
            width="100%"
            height="100%"
            :id="'ysy'+dataOne.number"
            allowfullscreen
          >
          </iframe>
        </div>
      </div>
      <div class="item_info">
        <div class="title">报警摘要：<span>进入</span></div>
        <div class="con">
          <div class="line">报警时间：{{dataOne.target_begin_time}}</div>
          <div class="line">报警摄像头：{{dataOne.title}}</div>
          <div class="line">摄像头编号：{{dataOne.number}}</div>
          <div class="line">报警接收：
            <ul>
              <li class="curr" v-if="dataOne.ste==0">未处理</li>
              <li v-else @click="checkSte(0)">未处理</li>

              <li class="curr" v-if="dataOne.ste==1">已处理</li>
              <li v-else @click="checkSte(1)">已处理</li>
              
              <li class="curr" v-if="dataOne.ste==2">误报</li>
              <li v-else @click="checkSte(2)">误报</li>
            </ul>
          </div>
          <div class="line">处理记录：</div>
          <div class="text_area">
            <el-input
              class="input_area"
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="dataOne.remark">
            </el-input>
          </div>
        </div>
      </div>
      <div class="clear"></div>
      <div class="sub_btn">
        <div class="btn_one" @click="updateWarn">提交</div>
        <div class="btn_one" @click="updateWarn">关闭</div>
      </div>
    </div>
  </div>
</template>
<script>
import aiListApi from "@/api/aivideo/aiList"
export default {
  name: "aiOne",
  props: {
    dataOne: {
      type: Object,
      required: true, // 默认值是false
      default: function () {
        return {
          alarm_id: 0,
          created_at: 0,
          number: "0",
          channel: 1, //通道号
          picture: "",
          ste: 0,
          remark: '',
          target_begin_time: "",
          target_name: "",
          title: "",
          type: 0
        }
      }
    },
    accessToken: {
      type: String,
      required: true, // 默认值是false
      default: function () {
        return ''
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    updateWarn(){
      aiListApi.aiUpdateWarn(this.dataOne.alarm_id, {ste:this.dataOne.ste,remark:this.dataOne.remark}).then((res) => {
        if (res.data.code === 1000) {
          this.$message({
            message: "成功",
            type: "success",
          });
          this.$emit('closeMethod')
        } else {
          this.$message.error(resp.data.message);
        }
      });
    },
    checkSte(ste) {
      this.dataOne.ste = ste
    }
  }
}
</script>
<style lang='less' scoped>
.aiOne-container {
    position: relative;
    width: 100%;
    height:100%;
    background: #060504;
    box-sizing: border-box;
    border:2px solid #ff7c2e;
    box-shadow: 0 0 30px rgba(0,0,0,0.5);
    padding:5px 10px;
    .aiOne_head{
      height:36px;
      position: relative;
      padding: 5px 10px;
      .title{
        font-size:18px;
        font-weight: bold;
        color:#ff7c2e;
        float: left;
        line-height: 36px;
      }
      .colse{
        float: right;
        font-size:26px;
        color:#ff7c2e;
        cursor: pointer;
        line-height: 36px;
      }
    }
    .aiOne_body{
      padding:0 5px 10px;
      .clear{
        width:100%;
        clear:both;
      }
      .item_one{
        width:360px;
        height:320px;
        float: left;
        margin:0 5px;
        display: inline;
        background: #3e3930;
        .title{
          line-height: 34px;
          color:#fff;
          font-size:16px;
          text-align: center;
        }
        .con{
          padding:0 5px 5px;
          line-height: 0;
          height:286px;
          box-sizing: border-box;
          img{
            width:100%;
            height:100%;
          }
          iframe{
            margin:0;
            border: 0;
            padding:0;
          }
        }
        
      }
      .item_info{
        width:318px;
        height:320px;
        margin-right: 5px;
        float: right;
        background: #3e3930;
        color:#fff;
        font-size:14px;
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        box-sizing: border-box;
        padding:12px;
        .con{
          width:100%;
        }
        .title{
          line-height: 34px;
          color:#fff;
          text-align: center;
          span{
            color:#ff0000;
            font-size:20px;
            font-weight: bold;
          }
        }
        .line{
          height:32px;
          display: flex;
          align-items: center;
          flex-direction: row;
          justify-content: space-between;
          ul{
            list-style: none;
            margin:0;
            padding:0;
            height:26px;
            li{
              float: left;
              margin-left: 5px;
              color:#fff;
              width:68px;
              text-align: center;
              line-height: 26px;
              background: #3c372f;
              cursor: pointer;
            }
            .curr{
              background: #ff7c2e;
            }
          }
        }
      }
      .sub_btn{
        float: right;
        height:32px;
        margin-top: 10px;
        .btn_one{
          background: #ff7c2e;
          color:#fff;
          width:80px;
          text-align: center;
          line-height:32px;
          margin:0 5px;
          float: left;
          font-size:14px;
          cursor: pointer;
        }
      }
    }


}
</style>
<style lang='less'>
.input_area{
  textarea{
    background: #3c372f !important;
    border:0 !important;
    color:#fff;
    height:100px;
    overflow-y: auto;
    padding:6px 10px;
  }
}
</style>